<template>
  <v-app>
    <v-content>
      <v-container>
        <v-layout>
          <v-dialog
            v-model="dialog"
            persistent
            max-width="600px"
            transition="dialog-transition">
            <v-card>
              <v-toolbar color="primary" dark dense>
                <img 
                  src="@/assets/nihr-logo.svg" 
                  alt="National Institute for Health and Care Research"
                  width="160">
                <v-toolbar-title class="title">Privacy Policy</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <p class="text-xs-left body-2 font-weight-medium"> {{privacyPolicy.policy}} </p>
                <p class="text-xs-left body-2 font-weight-medium">{{privacyPolicy.contactText}} <a :href="targetEmail" target='_blank'>{{privacyPolicy.contactEmail}}</a>  </p>
              </v-card-text>  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn 
                  flat 
                  outline
                  @click="dialog = !dialog">
                    Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-flex xs12 sm8 offset-sm2>
            <v-card>
              <v-toolbar
                dense
                flat
                card
                dark
                color="primary"
              >
                <img 
                  src="@/assets/nihr-logo.svg" 
                  alt="National Institute for Health and Care Research"
                  width="160">
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn 
                    color="info"
                    flat
                    small
                    @click="dialog = !dialog"
                  >Privacy Policy</v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-layout justify-center align-center fill-height>
                <v-card-text>
                  <p class="headline text-xs-center">
                    Thank you for registering to use
                    Mentor{{coachText}} Directory
                  </p>
                  <p class="subheading text-xs-center" v-if="!myProfile.name">
                    To be authorised please complete and submit the form below
                  </p>
                  <p class="subheading text-xs-center" v-else>
                    Your request for authorisation is in progress
                  </p>
                </v-card-text>
              </v-layout>
            </v-card>
            <v-card  v-if="!myProfile.name">
              <v-card-title>
                <span class="headline">User Information for {{userName}} </span>
              </v-card-title>
              <v-form @submit.prevent="saveChanges" ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs6>
                        <v-text-field 
                          v-model="profileForm.email"
                          readonly
                          label="Email"></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-select
                          :items="configData.locations"
                          v-model="profileForm.location"
                          :rules="[v => !!v || 'Primary Location is required']"
                          name="userLocation"
                          label="Primary Location"
                          id="Location"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field 
                          v-model="profileForm.telephone" 
                          label="Telephone"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          :items="employerList"
                          v-model="profileForm.employer"
                          :rules="[v => !!v || 'Employer is required']"
                          name="userEmployer"
                          label="Employer"
                          id="Employer"
                        ></v-select>
                      </v-flex>                    
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        I would like to register as a 
                        <v-radio-group 
                          v-model="profileForm.mentor"
                          value=false
                          :rules="[v => !!v || 'Please choose either Client of Mentor']"
                          row>
                          <v-radio label="Client" value=false></v-radio>
                          <v-radio label="Mentor" value=true></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          v-if="profileForm.mentor == 'true'"
                          type="number"
                          min="1" max="5"
                          v-model="profileForm.clientsLimit"
                          label="Limit of Concurrent Clients"
                          ></v-text-field> 
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          :items="configData.roles"
                          v-model="profileForm.role"
                          :rules="[v => !!v || 'Role is required']"
                          hint="Please select your main job role.  Select Clinical Research Practitioner if your main role is not explicitly listed."
                          persistent-hint
                          name="userRole"
                          label="Role"
                          id="Role"
                        ></v-select>
                        <br>
                        <v-select
                          :items="specialtyList"
                          v-model="profileForm.specialty"
                          :rules="[v => v.length > 0 || 'Specialty is required']"
                          multiple
                          hint="Please select ‘I do not have a specific specialty’ if your main role is not specialty based."
                          persistent-hint
                          name="userSpecialty"
                          label="Specialty"
                          id="Specialty"
                        ></v-select>
                        <br>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          :items="configData.topics"
                          v-model="profileForm.topics"
                          :rules="[v => v.length > 0 || 'Topics is required, please select at least one']"
                          multiple
                          hint="Please select the topics that you would either like to receive mentor support on, or that you would like to provide mentor support to others about."
                          persistent-hint
                          name="userTopics"
                          label="Topics"
                          id="Topics"
                        ></v-select>
                        <br>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea 
                          v-model="profileForm.bio"
                          :rules="[v => !!v || 'Background is required']"
                          placeholder="Please add some information here about your experience and background. For example previous roles and research experience, research projects that you may have been involved in, and other interests. This will help people to decide whether you may be a good potential match."
                          label="Background"></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    outline 
                    color="primary" 
                    dark
                    type="submit">
                      Save
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
  
export default {
  name: 'notauth',
  data () {
    return {
      dialog: false,
      valid: true,
      profileForm: {
        admin: false,
        authorised: false,
        available: "Available",
        bio: null,
        clientsCurrent: 0,
        clientsLimit: 1,
        email: null,
        location: null,
        mentor: false,
        name: this.userName,
        role: null,
        specialty: [],
        telephone: null,
        topics: []
      }
    }
  },
  computed: {
    userEmail: function () {
      // get the current user's email from the store
      return this.$store.getters.getUserEmail
    },
    userName: function () {
      // get the current user's display name from the store
      return this.$store.getters.getUserName
    },
    configData: function () {
      // get the configuration data from the store
      return this.$store.getters.getConfig
    },
    storeLoading: function () {
      // get the 
      return this.$store.getters.getStoreLoading
    },
    progressColour: function() {
      return this.$store.getters.getProgressColour
    },
    errorMessage: function () {
      return this.$store.getters.getErrorMessage
    },
    myProfile: function() {
      // get the current user's profile from the store
      return this.$store.getters.getMyProfile
    },
    specialtyList: function () {
      // get the list of specialties from the store and make sure
      // "I do not have a specific specialty" is at the top not sorted alphabetically
      var noSpecialty = ["I do not have a specific specialty"]
      return noSpecialty.concat(this.configData.specialty) 
    },
    privacyPolicy: function() {
      // get the privacy policy from the store
      return this.$store.getters.getPrivacyPolicy
    },
    targetEmail: function () {
      return "mailto: "+this.privacyPolicy.contactEmail
    },
    employerList: function () {
      var allEmp = this.configData.employer.filter(employer => employer.location == 'All')
      var locationEmp = this.configData.employer.filter(employer => employer.location == this.profileForm.location)
      var fullEmp = locationEmp.concat(allEmp)

      return fullEmp.map(employer => employer.employer)
    },
    includeCoach: function () {
        return this.$store.getters.getIncludeCoach
      },
    coachText: function () {
      if (this.includeCoach) {
        return '/Coach'
      } else {
        return ''
      }
    }
  },
  created() {
    this.$store.dispatch('updatePrivacyPolicy')
    // make sure we're at the top of the form (especially useful if we're returning from one of the forms)
    window.scrollTo(0, 0);
    // make sure the store has the latest version of the configuration data
    this.$store.dispatch("updateConfig")
    //this.$store.dispatch("updateAppTitle")
    // set the user enail and name from the authenticated account into the unsaved profile data
    this.profileForm.email = this.userEmail
    this.profileForm.name = this.userName
    console.log("NotAuth - myProfile ", this.myProfile)
    //log the un-authorised user out of the app so using the back button will return them to the login screen
    if (this.myProfile.name) {
      this.logOut()
    }
  },
  methods: {
    logOut: function() {
      firebase.auth().signOut()
        .then(() => {
          console.log("Un-Authorised User Logged Out!")
        })
    },
    saveChanges() {
      if (this.$refs.form.validate()) {
        //ensure the mentor flag is a boolean value not a string
        if (this.profileForm.mentor == 'true') {
          this.profileForm.mentor = true
        } else {
          this.profileForm.mentor = false
        }

        this.$forceUpdate();
        this.$store.dispatch("saveMyProfile",this.profileForm)
      }
    }
  }
}
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .card-form-list {
      margin-top: 10px;
  }
    
  .card-study-site {
      margin-top: 10px;
  }

  p {
    white-space: pre-line;
  }
</style>
